import { render, staticRenderFns } from "./consoleNav.vue?vue&type=template&id=6251ebe2&scoped=true"
import script from "./consoleNav.vue?vue&type=script&lang=js"
export * from "./consoleNav.vue?vue&type=script&lang=js"
import style0 from "./consoleNav.vue?vue&type=style&index=0&id=6251ebe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6251ebe2",
  null
  
)

export default component.exports